


// // import React, { useState } from "react";
// // import {
// //   Grid,
// //   Button,
// //   Box,
// //   Typography,
// //   Paper,
// //   LinearProgress,
// //   IconButton,
// //   Dialog,
// //   DialogContent,
// //   DialogTitle,
// // } from "@mui/material";
// // import { FiUpload } from "react-icons/fi";
// // import { HiDocumentArrowUp } from "react-icons/hi2";
// // import { RiDeleteBin2Line } from "react-icons/ri";
// // import { FaEye } from "react-icons/fa6";
// // import { IoMdCloseCircleOutline } from "react-icons/io";
// // // import { useDispatch } from "react-redux";
// // // import actions from "../../ReduxStore/actions";
// // // import { adminUrl } from "../../constants";

// // const MultipleFileUploadComponent = ({
// //   name,
// //   onFileUpload,
// //   uploadedFile,
// //   setUploadedFile,
// //   selectedDocumentType,
// // }) => {
// //   const [openPreview, setOpenPreview] = useState(false);
// //   console.log(uploadedFile, "uploadedFile")

// //   const handleFileUpload = async (event) => {
// //     const file = event.target.files[0];
// //     console.log("workkkk")

// //     if (file) {
// //       const fileType = file.type.includes("image") ? "image" : "pdf";
// //       console.log(fileType, "fileType")
// //       console.log("workkkk11")

// //       const fileUrl = URL.createObjectURL(file); // Create a temporary URL for preview

// //       setUploadedFile({ fileUrl, type: fileType, progress: 100 });
// //       onFileUpload(fileUrl);
// //     }
// //   };


// //   const handleFileDelete = () => {
// //     setUploadedFile(null);
// //     onFileUpload(null);
// //   };

// //   return (
// //     <Grid>
// //       <label htmlFor={`file-upload-${name}`} style={{ fontSize: "16px", paddingBottom: "10px" }}>
// //       Select File{" "}
// //         <span style={{ fontSize: "11px", color: "#7A7A7A" }}>(Supported: .png, .jpg, .pdf)</span>
// //       </label>

// //       <input
// //         accept=".png,.jpg,.pdf"
// //         style={{ display: "none" }}
// //         id={`file-upload-${name}`}
// //         type="file"
// //         name={name}
// //         onChange={handleFileUpload}
// //       />

// //       <label htmlFor={`file-upload-${name}`} style={{ marginTop: "10px" }}>
// //         <Button
// //           component="span"
// //           startIcon={<FiUpload style={{ fontSize: "14px" }} />}
// //           sx={{
// //             width: "100%",
// //             color: "white",
// //             background: "var(--main-color)",
// //             borderRadius: "3px",
// //             fontSize: "14px",
// //             textTransform: "none",
// //             height:"35px",
// //             marginTop:"3px"
// //           }}
// //         >
// //           Browse
// //         </Button>
// //       </label>

// //       {uploadedFile && (
// //         <Grid item xs={12} mt={2}>
// //           <Paper
// //             elevation={3}
// //             sx={{
// //               padding: "5px",
// //               background: "#F7F7F7",
// //               display: "flex",
// //               justifyContent: "space-between",
// //               alignItems: "center",
// //             }}
// //           >
// //             <Box sx={{ display: "flex", alignItems: "center" }}>
// //               <HiDocumentArrowUp style={{ fontSize: "30px", color: "#C38F51", marginRight: "10px" }} />
// //             </Box>

// //             <Box sx={{ width: "100%" }}>
// //               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
// //                 <Typography variant="body1" sx={{ fontSize: "12px" }}>
// //                   {uploadedFile.type}
// //                 </Typography>
// //                 <Box>
// //                   <IconButton onClick={() => setOpenPreview(true)} sx={{ color: "black" }}>
// //                     <FaEye style={{ fontSize: "14px" }} />
// //                   </IconButton>
// //                   <IconButton
// //                     onClick={handleFileDelete}
// //                     sx={{
// //                       color: "black",
// //                       "&:hover": { color: "red" },
// //                     }}
// //                   >
// //                     <RiDeleteBin2Line style={{ fontSize: "14px" }} />
// //                   </IconButton>
// //                 </Box>
// //               </Box>

// //               <LinearProgress
// //                 variant="determinate"
// //                 value={uploadedFile.progress}
// //                 sx={{
// //                   height: "6px",
// //                   borderRadius: "10px",
// //                   backgroundColor: "lightgray",
// //                   "& .MuiLinearProgress-bar": {
// //                     backgroundColor: uploadedFile.progress === 100 ? "#1FC45B" : "red",
// //                   },
// //                 }}
// //               />

// //               <Box display="flex" justifyContent="end">
// //                 <Typography
// //                   variant="body1"
// //                   fontSize="12px"
// //                   color={uploadedFile.progress === 100 ? "green" : "red"}
// //                 >
// //                   {uploadedFile.progress === 100 ? "Upload Successful!" : `${uploadedFile.progress}%`}
// //                 </Typography>
// //               </Box>
// //             </Box>
// //           </Paper>
// //         </Grid>
// //       )}

// //       {/* Preview Dialog */}
// //       <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="md" fullWidth>
// //         <DialogTitle>
// //           <Typography variant="subtitle1">Preview</Typography>
// //           <IconButton
// //             onClick={() => setOpenPreview(false)}
// //             sx={{ position: "absolute", right: 8, top: 8 }}
// //           >
// //             <IoMdCloseCircleOutline />
// //           </IconButton>
// //         </DialogTitle>

// //         <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

// //           {uploadedFile?.fileUrl && uploadedFile?.type.startsWith("image/") ? (
// //             <img
// //               src={`${uploadedFile?.fileUrl}`}
// //               alt="Preview"
// //               style={{ maxWidth: "100%", maxHeight: "500px", objectFit: "contain" }}
// //             />
// //           ) : (
// //             <iframe
// //               src={`${uploadedFile?.fileUrl}`}
// //               title="PDF Preview"
// //               width="100%"
// //               height="500px"
// //               style={{ border: "none" }}
// //             />
// //           )}
// //         </DialogContent>
// //       </Dialog>
// //     </Grid>
// //   );
// // };

// // export default MultipleFileUploadComponent;


// import React, { useState } from "react";
// import {
//     Grid,
//     Button,
//     Box,
//     Typography,
//     Paper,
//     LinearProgress,
//     IconButton,
//     Dialog,
//     DialogContent,
//     DialogTitle,
// } from "@mui/material";
// import { FiUpload } from "react-icons/fi";
// import { HiDocumentArrowUp } from "react-icons/hi2";
// import { RiDeleteBin2Line } from "react-icons/ri";
// import { FaEye } from "react-icons/fa6";
// import { IoMdCloseCircleOutline } from "react-icons/io";

// const MultipleFileUploadComponent = ({ onFilesChange }) => {
//     const [uploadedFiles, setUploadedFiles] = useState([]);
//     const [previewFile, setPreviewFile] = useState(null);

//     const handleFileUpload = (event) => {
//         const files = Array.from(event.target.files);

//         const newFiles = files.map((file) => {
//             const type = file.type.includes("image") ? "image" : "pdf";
//             const fileUrl = URL.createObjectURL(file);

//             return {
//                 id: Math.random().toString(36).substr(2, 9),
//                 name: file.name,
//                 file,
//                 fileUrl,
//                 type,
//                 progress: 100,
//             };
//         });

//         const updatedFiles = [...uploadedFiles, ...newFiles];
//         setUploadedFiles(updatedFiles);
//         if (onFilesChange) onFilesChange(updatedFiles);
//     };

//     const handleDelete = (id) => {
//         const updated = uploadedFiles.filter((file) => file.id !== id);
//         setUploadedFiles(updated);
//         if (onFilesChange) onFilesChange(updated);
//     };

//     return (
//         <Box>
//             <Typography variant="body1" mb={1}>
//                 Select Files{" "}
//                 <span style={{ fontSize: "12px", color: "#888" }}>(Supported: .png, .jpg, .pdf)</span>
//             </Typography>

//             <input
//                 id="multi-upload"
//                 type="file"
//                 accept=".png,.jpg,.jpeg,.pdf"
//                 multiple
//                 hidden
//                 onChange={handleFileUpload}
//             />
//             <label htmlFor="multi-upload">
//                 <Button
//                     component="span"
//                     startIcon={<FiUpload />}
//                     sx={{
//                         background: "var(--main-color, #007bff)",
//                         color: "white",
//                         borderRadius: "4px",
//                         textTransform: "none",
//                         height: 40,
//                         width: "100%",
//                     }}
//                 >
//                     Browse Files
//                 </Button>
//             </label>

//             {uploadedFiles && (
//                     <Grid item xs={12} mt={2}>
//                       <Paper
//                         elevation={3}
//                         sx={{
//                           padding: "5px",
//                           background: "#F7F7F7",
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                         }}
//                       >
//                         <Box sx={{ display: "flex", alignItems: "center" }}>
//                           <HiDocumentArrowUp style={{ fontSize: "30px", color: "#C38F51", marginRight: "10px" }} />
//                         </Box>

//                         <Box sx={{ width: "100%" }}>
//                           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                             <Typography variant="body1" sx={{ fontSize: "12px" }}>
//                               {uploadedFiles.type}
//                             </Typography>
//                             <Box>
//                               <IconButton onClick={() => setPreviewFile(true)} sx={{ color: "black" }}>
//                                 <FaEye style={{ fontSize: "14px" }} />
//                               </IconButton>
//                               <IconButton
//                                 onClick={handleDelete}
//                                 sx={{
//                                   color: "black",
//                                   "&:hover": { color: "red" },
//                                 }}
//                               >
//                                 <RiDeleteBin2Line style={{ fontSize: "14px" }} />
//                               </IconButton>
//                             </Box>
//                           </Box>

//                           <LinearProgress
//                             variant="determinate"
//                             value={uploadedFiles.progress}
//                             sx={{
//                               height: "6px",
//                               borderRadius: "10px",
//                               backgroundColor: "lightgray",
//                               "& .MuiLinearProgress-bar": {
//                                 backgroundColor: uploadedFiles.progress === 100 ? "#1FC45B" : "red",
//                               },
//                             }}
//                           />

//                           <Box display="flex" justifyContent="end">
//                             <Typography
//                               variant="body1"
//                               fontSize="12px"
//                               color={uploadedFiles.progress === 100 ? "green" : "red"}
//                             >
//                               {uploadedFiles.progress === 100 ? "Upload Successful!" : `${uploadedFiles.progress}%`}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </Paper>
//                     </Grid>
//                   )}

//             {/* Preview Modal */}
//             <Dialog open={!!previewFile} onClose={() => setPreviewFile(null)} maxWidth="md" fullWidth>
//                 <DialogTitle>
//                     Preview
//                     <IconButton
//                         onClick={() => setPreviewFile(null)}
//                         sx={{ position: "absolute", right: 8, top: 8 }}
//                     >
//                         <IoMdCloseCircleOutline />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent>
//                     {previewFile && previewFile.fileUrl && (
//                         previewFile.type === "image" ? (
//                             <img
//                                 src={previewFile.fileUrl}
//                                 alt="preview"
//                                 style={{ maxWidth: "100%", maxHeight: "500px" }}
//                             />
//                         ) : (
//                             <iframe
//                                 src={previewFile.fileUrl}
//                                 title="PDF Preview"
//                                 width="100%"
//                                 height="500px"
//                                 style={{ border: "none" }}
//                             />
//                         )
//                     )}

//                 </DialogContent>
//             </Dialog>
//         </Box>
//     );
// };

// export default MultipleFileUploadComponent;


import React, { useState } from "react";
import {
    Grid,
    Button,
    Box,
    Typography,
    Paper,
    LinearProgress,
    IconButton,
    Dialog,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { FiUpload } from "react-icons/fi";
import { HiDocumentArrowUp } from "react-icons/hi2";
import { RiDeleteBin2Line } from "react-icons/ri";
import { FaEye, FaStarOfLife } from "react-icons/fa6";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useDispatch } from "react-redux";
import actions from "../../ReduxStore/actions";
import { adminUrl } from "../../constants";

const MultipleFileUploadComponent = ({ onFilesChange, uploadedFiles, setUploadedFiles }) => {
    // const [uploadedFiles, setUploadedFiles] = useState([]);
    const [previewFile, setPreviewFile] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([])
    console.log(previewFile, "previewFile")

    console.log(uploadedFiles, "uploadedFiles")
    // const handleFileUpload = (event) => {
    //     const files = Array.from(event.target.files);

    //     const newFiles = files.map((file) => {
    //         const type = file.type.includes("image") ? "image" : "pdf";
    //         const fileUrl = URL.createObjectURL(file);

    //         return {
    //             id: Math.random().toString(36).substr(2, 9),
    //             name: file.name,
    //             file,
    //             fileUrl,
    //             type,
    //             progress: 100,
    //         };
    //     });

    //     // const updatedFiles = [...uploadedFiles, ...newFiles];
    //     const updatedFiles = [...(uploadedFiles || []), ...newFiles];

    //     setUploadedFiles(updatedFiles);
    //     if (onFilesChange) onFilesChange(updatedFiles);
    // };

    // const handleDelete = (id) => {
    //     const updated = uploadedFiles.filter((file) => file.id !== id);
    //     setUploadedFiles(updated);
    //     if (onFilesChange) onFilesChange(updated);
    // };

    // const handleDelete = (id) => {
    //     const updated = uploadedFiles.filter((file) => file.id !== id);
    //     setUploadedFiles(updated);
    //     if (onFilesChange) onFilesChange(updated);
    // };
    const dispatch = useDispatch()
    const handleFileUpload = async (e) => {
        const files = Array.from(e.target.files); // All selected files
        if (files.length === 0) return;

        const updatedFiles = [...selectedFiles, ...files];
        setSelectedFiles(updatedFiles);

        const formData = new FormData();
        updatedFiles.forEach((file) => {
            formData.append("uploadFiles", file); // Append with same key
        });

        const data1 = {
            data: formData,
            method: "post",
            apiName: "multiplefiles",
        };

        try {
            const response = await dispatch(actions.UPLOADPDFILEPOST(data1));
            console.log(response, "uploadPdfAndImageResponse");

            const uploaded = response?.payload?.data?.files;

            // Assuming `uploaded` is an array
            // if (Array.isArray(uploaded)) {
            //     const uploadedFileObjects = uploaded.map(file => ({
            //         fileUrl: file.fileUrl,
            //         type: file.fileType,
            //         progress: 100,
            //     }));

            setUploadedFiles(response?.payload?.data?.files);
            // }

        } catch (error) {
            console.error("Upload failed:", error);
        }
    };




    const handleDelete = (index) => {
        const fileToDelete = uploadedFiles[index];

        if (fileToDelete?.fileUrl) {
            URL.revokeObjectURL(fileToDelete.fileUrl); // Only if it was a blob URL
        }

        const updated = uploadedFiles.filter((_, i) => i !== index);
        setUploadedFiles(updated);
        if (onFilesChange) onFilesChange(updated);
    };


    return (
        <Box>
            {/* <Typography variant="subtitle1">
                Select Multiple Files{" "}
                <span style={{ fontSize: "12px", color: "#888" }}>(Supported: .png, .jpg, .jpeg)</span>

            </Typography> */}
            <Typography variant="body1">
                <label
                    // htmlFor={name}
                    className="input-heading12"
                    style={{ fontSize: "15px", fontWeight: "450", color: "black" }}
                >
                    Select Multiple Files{" "}
                    <span style={{ fontSize: "12px", color: "#888" }}>(Supported: .png, .jpg, .jpeg)</span>

                </label>

                {/* {important && (
                    <FaStarOfLife style={{ color: '#F53E5C', fontSize: "8px", marginLeft: "3px" }} />
                )} */}
            </Typography>

            <input
                id="multi-upload"
                type="file"
                accept=".png,.jpg,.jpeg,.pdf,.mp4"
                multiple
                hidden
                onChange={handleFileUpload}
            />
            <label htmlFor="multi-upload">
                <Button
                    component="span"
                    startIcon={<FiUpload />}
                    sx={{
                        background: "var(--main-color, #007bff)",
                        color: "white",
                        borderRadius: "4px",
                        textTransform: "none",
                        height: 35,
                        width: "100%",
                    }}
                >
                    Browse Files
                </Button>
            </label>

            {uploadedFiles?.map((file, index) => (
                <Grid item xs={12} mt={2} key={index}>
                    <Paper
                        elevation={3}
                        sx={{
                            padding: "10px",
                            background: "#F7F7F7",
                            display: "flex",
                            gap: 2,
                            alignItems: "center",
                        }}
                    >
                        <HiDocumentArrowUp style={{ fontSize: "30px", color: "var(--main-color)" }} />
                        <Box sx={{ flexGrow: 1 }}>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography variant="body1" color="black">
                                    {file.fileType}
                                    {/* image */}
                                </Typography>
                                <Box>
                                    <IconButton
                                        onClick={() => setPreviewFile(file)}
                                        sx={{ color: "black" }}
                                    >
                                        <FaEye fontSize={16} />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => handleDelete(index)}
                                        sx={{
                                            color: "black",
                                            "&:hover": { color: "red" },
                                        }}
                                    >
                                        <RiDeleteBin2Line fontSize={16} />
                                    </IconButton>
                                </Box>
                            </Box>

                            <LinearProgress
                                variant="determinate"
                                value={100}
                                sx={{
                                    height: 6,
                                    borderRadius: 10,
                                    // mt: 1,
                                    backgroundColor: "lightgray",
                                    "& .MuiLinearProgress-bar": {
                                        // backgroundColor: file.progress === 100 ? "#1FC45B" : "red",
                                        backgroundColor: "#1FC45B",

                                    },
                                }}
                            />
                            <Box display="flex" justifyContent="flex-end">
                                <Typography
                                    variant="caption"
                                    color="green"
                                >
                                    Upload Successful!
                                    {/* {file.progress === 100
                                        ? "Upload Successful!"
                                        : `${file.progress}%`} */}
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
            ))}

            {/* Preview Modal */}
            <Dialog open={!!previewFile} onClose={() => setPreviewFile(null)} maxWidth="md" fullWidth>
                <DialogTitle>
                    Preview
                    <IconButton
                        onClick={() => setPreviewFile(null)}
                        sx={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <IoMdCloseCircleOutline />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {previewFile && previewFile.fileUrl && (
                        previewFile.fileType === "image" ? (
                            <img
                                src={`${adminUrl}${previewFile?.fileUrl}`}
                                alt="preview"
                                style={{ maxWidth: "100%", maxHeight: "500px" }}
                            />
                        ) : previewFile.fileType === "video" ? (
                            <video
                                src={`${adminUrl}${previewFile?.fileUrl}`}
                                controls
                                width="100%"
                                height="500px"
                                style={{ border: "none" }}
                            >
                                Your browser does not support the video tag.
                            </video>



                        ) : (
                            <iframe
                                src={`${adminUrl}${previewFile?.fileUrl}`}
                                title="PDF Preview"
                                width="100%"
                                height="500px"
                                style={{ border: "none" }}
                            />
                        )
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default MultipleFileUploadComponent;
